import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { customerservice } from "../../../../../config";
import GroupRoleForm from "./form";
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride"; // Import Joyride


const base_url = customerservice.uri;
// Define Joyride tour steps
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Group Roles Management page, where you can manage a group roles for the members.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find a specific role by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new role.",
    placement: "right",
  },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each role from this dropdown.",
    placement: "left",
  },
];

const GroupRolesTable = () => {
  const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
const groupId= localStorage.getItem("GroupId")
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const navigate = useNavigate();

  const actions = {
    entity: "Group Roles",
    isSubright:true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    dataObject: {
      ignoreFields: ["UpdateDate", "CreateDate",],
      objectName: "groupRolesByColumnValues",
      parameters:{groupId:parseInt(groupId)},
      inputObjectName:"groupRole"
    },

  };

  return (
    <Box m="20px">
       {/* Joyride Component */}
            <Joyride
              steps={rightsTourSteps}
              run={runTour}
              continuous
              showSkipButton
              showProgress
              styles={{
                options: {
                  primaryColor: "#1976d2",
                  zIndex: 10000,
                },
              }}
            />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
       <Button onClick={ () => navigate(-1)} variant="contained">
            Back to Groups
          </Button>
      <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
                    Start Page Tour
            </Button>
      </Box>
      <>
      </>
      <DynamicTableForJson
        title="Group Roles"
        subtitle="Manage Group Roles"
        FormComponent={GroupRoleForm}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Still passed in case DynamicTable needs it
      />
    </Box>
  );
};

export default GroupRolesTable;
